import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ToolsService} from '../tools/tools.service';

export interface TranslationOverrideByKey {
  [shortCode: string]: { id: number; value: string };
}

export interface TranslationOverrideUpsertResult {
  id: number;
  key: string;
  langSrc: string;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationOverrideService {

  constructor(
    private http: HttpClient,
    private toolsSrv: ToolsService
  ) {
  }

  /**
   * Renvoie la map { clé: valeur } des overrides actives pour une langue source.
   */
  async loadForLangSrc(shortCode: string): Promise<{ [key: string]: string }> {
    const url = `${this.toolsSrv.getApiEndpoint()}translation_overrides?lang_src=${encodeURIComponent(shortCode)}`;
    return await this.http.get<{ [key: string]: string }>(url).toPromise() ?? {};
  }

  /**
   * Renvoie toutes les langues d'une clé : { fr: {id, value}, en: {id, value}, ... }
   */
  async getByKey(key: string): Promise<TranslationOverrideByKey> {
    const url = `${this.toolsSrv.getApiEndpoint()}translation_overrides/by_key?key=${encodeURIComponent(key)}`;
    return await this.http.get<TranslationOverrideByKey>(url).toPromise() ?? {};
  }

  /**
   * Crée ou met à jour une override (auto-save par cellule).
   */
  async upsert(key: string, langSrc: string, value: string): Promise<TranslationOverrideUpsertResult> {
    const url = `${this.toolsSrv.getApiEndpoint()}translation_overrides`;
    return await this.http.post<TranslationOverrideUpsertResult>(url, {key, langSrc, value}).toPromise();
  }

  /**
   * Soft-delete d'une override.
   */
  async delete(id: number): Promise<void> {
    const url = `${this.toolsSrv.getApiEndpoint()}translation_overrides/${id}`;
    await this.http.delete(url).toPromise();
  }
}
